import { render, staticRenderFns } from "./KnowledgeArticle.vue?vue&type=template&id=0effc22a&lang=pug"
import script from "./KnowledgeArticle.vue?vue&type=script&lang=js"
export * from "./KnowledgeArticle.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeArticle.vue?vue&type=style&index=0&id=0effc22a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports